{
  "version": 1,
  "asset_id": "eef07758-f777-40ee-831e-22f4d6d8fd6e",
  "project_id": "4dbb42ac-931e-41e9-ac57-3f509e458f26",
  "url": "/__l5e/assets-v1/eef07758-f777-40ee-831e-22f4d6d8fd6e/signature-placeholder.jpg",
  "r2_key": "a/v1/4dbb42ac-931e-41e9-ac57-3f509e458f26/eef07758-f777-40ee-831e-22f4d6d8fd6e/signature-placeholder.jpg",
  "original_filename": "signature-placeholder.jpg",
  "size": 335851,
  "content_type": "image/jpeg",
  "created_at": "2026-09-06T14:55:20Z"
}
